const menu = {
  key: "addresses",
  route: "/legacy/addresses",
  label: "sidebar.addresses",
  icon: "faLocationDot",
  group: "masterdata",
  order: 10,
  permission: "legacy.addresses.read"
};

export default menu;